
export const text = `The first thing to observe is the actors in the video. If any of their voices have been replaced, first try adjusting your audio. If all of the voices have been swapped, this is nothing to be concerned about. Just keep watching the video until the voices are correctly realigned. Your quality assurance and feedback are appreciated. 

If all of the voices in the video are your voice, leave your address in an unmarked manilla envelope in your dead drop. 

`